import { render } from "./KnotKeyboard.vue?vue&type=template&id=3fb432f7&scoped=true"
import script from "./KnotKeyboard.vue?vue&type=script&lang=js"
export * from "./KnotKeyboard.vue?vue&type=script&lang=js"

import "./KnotKeyboard.vue?vue&type=style&index=0&id=3fb432f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb432f7"]])

export default __exports__